import { useEffect } from 'react';
import { clearStalePreloadMarker } from '../utils/stalePreloadRecovery';

/**
 * GH#914 — the "we recovered" signal for the stale-chunk reload policy.
 *
 * Renders nothing. Its only job is WHERE it mounts: as a child of the single
 * <Suspense> that wraps the lazy routes, so its effect runs only once the
 * route's chunk has actually loaded and committed.
 *
 * That timing is the whole point. Clearing on shell mount instead —
 * immediately after ReactDOM.render() — clears while the chunk is still in
 * flight, so a retry that also fails finds an empty marker and reloads again,
 * forever. The reload policy promises "at most once"; only a signal that the
 * page genuinely recovered can safely reset it.
 */
export function StalePreloadHealthBeacon() {
  useEffect(() => {
    clearStalePreloadMarker(window.sessionStorage);
  }, []);
  return null;
}

export default StalePreloadHealthBeacon;
